import type {EditionApiModel} from '../../../../api/program';
import type {Nullable} from '../../../utility-types';

export const isEditionPaymentPlanInternal = (
  edition?: Nullable<EditionApiModel>,
): boolean => edition?.payment_plan?.processing === 'internal';
